import { Route, Routes } from 'react-router-dom';

// components
import PageNotFound from './pages/PageNotFound';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import DefaultLayout from './layouts/DefaultLayout';
import SimpleLayout from './layouts/SimpleLayout';
import DevComponents from './pages/DevComponents';
import Project from './pages/Project';
import ProjectMyStudio from './pages/ProjectMyStudio';
import Registration from './pages/Registration';
import ResetPassword from './pages/ResetPassword';
import UpdatePassword from './pages/UpdatePassword';
import Projects from './pages/Projects';
import AcceptInvitation from './pages/AcceptInvitation';
import Profile from './pages/Profile';

const routes = ({ role }) => {
    return (
        <Routes>
            <Route element={<ProtectedRoute/>}>
                <Route path="/" element={<DefaultLayout>
                    <Dashboard/>
                </DefaultLayout>}/>
            </Route>
            <Route element={<ProtectedRoute/>}>
                <Route path="/projects" element={<DefaultLayout>
                    <Projects/>
                </DefaultLayout>}/>
            </Route>
            <Route element={<ProtectedRoute/>}>
                <Route path="/projects/:projectId" element={<DefaultLayout>
                    <Project/>
                </DefaultLayout>}/>
            </Route>
            <Route element={<ProtectedRoute/>}>
                <Route path="/projects/:projectId/studio" element={<DefaultLayout>
                    <ProjectMyStudio/>
                </DefaultLayout>}/>
            </Route>
            <Route element={<ProtectedRoute/>}>
                <Route path="/profile" element={<DefaultLayout>
                    <Profile/>
                </DefaultLayout>}/>
            </Route>
            <Route exact path="/login" element={<SimpleLayout>
                <Login/>
            </SimpleLayout>}/>
            <Route exact path="/reset-password" element={<SimpleLayout>
                <ResetPassword/>
            </SimpleLayout>}/>
            <Route exact path="/update-password" element={<SimpleLayout>
                <UpdatePassword/>
            </SimpleLayout>}/>
            <Route exact path="/registration" element={<SimpleLayout>
                <Registration/>
            </SimpleLayout>}/>
            <Route exact path="/accept" element={<SimpleLayout>
                <AcceptInvitation/>
            </SimpleLayout>}/>
            <Route path="/dev-components" element={<SimpleLayout>
                <DevComponents/>
            </SimpleLayout>}/>
            <Route path="*" element={<SimpleLayout>
                <PageNotFound/>
            </SimpleLayout>}/>
        </Routes>)
};

export default routes;
